import React from 'react';

import { Action } from 'state';
import Field from 'types/Field';
import FieldType from 'types/FieldType';
import Section from 'types/Section';
import NumericFieldPreview from './NumericFieldPreview';
import MultiSelectFieldPreview from './MultiSelectFieldPreview';
import SingleSelectFieldPreview from './SingleSelectFieldPreview';
import TextAreaFieldPreview from './TextAreaFieldPreview';
import TextFieldPreview from './TextFieldPreview';

interface FieldPreviewProps {
  field: Field;
  section: Section;
  dispatch: (action: Action) => void;
}

const FieldPreview: React.FC<FieldPreviewProps> = ({ field, section, dispatch }) => {
  return (
    <>
      {field.input_type === FieldType.SINGLE_SELECT ? (
        <SingleSelectFieldPreview field={field} section={section} dispatch={dispatch} />
      ) : field.input_type === FieldType.MULTI_SELECT ? (
        <MultiSelectFieldPreview field={field} section={section} dispatch={dispatch} />
      ) : field.input_type === FieldType.TEXT ? (
        <TextFieldPreview section={section} field={field} dispatch={dispatch} />
      ) : field.input_type === FieldType.TEXT_AREA ? (
        <TextAreaFieldPreview field={field} section={section} dispatch={dispatch} />
      ) : field.input_type === FieldType.NUMERIC ? (
        <NumericFieldPreview section={section} field={field} dispatch={dispatch} />
      ) : null}
    </>
  );
};

export default FieldPreview;
